const AGREE = "Agree";
const CLOSE = "Close";
const COMMENT = "Comment";
const DECLINE = "Decline";
const DISCUSS = "Discuss";
const REQUEST = "Request";

export { AGREE, CLOSE, COMMENT, DECLINE, DISCUSS, REQUEST };
